import defaultColorPalette from "./light_defaultPalette";

import * as colors from "../../colors";

import { DoubleExtendedPalette } from "../../models/theme.types";

const colorPalette: Partial<DoubleExtendedPalette> = {
	type: "light",
	...defaultColorPalette,
	primary: {
		text: colors.basic[800],
		contrastText: colors.basic[100],
		dark: colors.green[500],
		light: colors.green[200],
		main: colors.green[600],
		tabs: {
			border: colors.green[500],
			contrastText: colors.green[800],
			main: colors.green[300]
		}
	},
	secondary: {
		text: colors.basic[600],
		contrastText: colors.green[600],
		dark: colors.green[100],
		light: colors.green[200],
		main: colors.green[200],
		tabs: {
			contrastText: colors.green[800],
			dark: colors.green[500],
			main: colors.green[200],
			border: colors.green[600]
		}
	}
};

export default colorPalette;
